(function(){
  var timer;
  var speed = 50;
  var unit = 50;

  PegasusTemplate.ScrollRegionView = Ember.View.extend({
    classNames: ['vr-scroll-region'],
    classNameBindings: ['position'],
    position: Em.required(),
    isVisible: false,

    didInsertElement: function(){
      var self = this;
      $(window).on('dragstart.' +this.get('elementId'), function(){
        Em.run( self, 'didStart');
      });
      $(window).on('dragenter.' +this.get('elementId'), function(){
        Em.run( self, 'didStart');
      });
      $(window).on('dragend.' + this.get('elementId'), function(){
        Em.run( self, 'set', 'isVisible', false);
      });
      $(window).on('drop.' + this.get('elementId'), function(){
        Em.run( self, 'set', 'isVisible', false);
      });
      $(window).on('mouseup.' + this.get('elementId'), function(){
        Em.run( self, 'set', 'isVisible', false);
      });
      $(window).on('didScroll', function(){
        Em.run( self, 'set', 'isVisible', true);
      });
    },

    didStart: function(){
      var a = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

      if ( this.get('isTop') && a === 0 ) {
        this.set('isVisible', false);
        return;
      }

      this.set('isVisible', true);
    },

    willDestroyElement: function(){
      var $w = $(window);
      var id = this.get('elementId');

      $w.off('dragstart.' + id);
      $w.off('dragenter.' + id);
      $w.off('dragend.' + id);
      $w.off('drop.' + id);
      $w.off('mouseup.' + id);
      this._super();
    },

    isTop: function(){
      return this.get('position') === 'top-scroll-region';
    }.property('position'),

    isBottom: Ember.computed.not( 'isTop' ),

    doScroll: function(){
      try {
        var scroller = $('html');

        this.set('isVisible', true);

        var scrollTop  = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

        if ( this.get('isTop') ) {
          if ( scrollTop === 0 ) {
            this.set('isVisible', false);
            return;
          }
          scroller.scrollTo( scrollTop - unit );
          timer = Em.run.later( this, 'doScroll', speed );
        } else {
          scroller.scrollTo( scrollTop + unit );
          timer = Em.run.later( this, 'doScroll', speed );
        }

        $(window).trigger('didScroll');
      } catch(e) {}
    },

    drop: function(){
      Em.run.cancel(timer);
    },

    dragEnter: function(e){
      e.stopPropagation();
      Em.run.cancel(timer);
      this.doScroll();
    },

    dragLeave: function(e){
      e.stopPropagation();
      Em.run.cancel(timer);
    }
  });
})();

PegasusTemplate.ScrollRegionTopView = PegasusTemplate.ScrollRegionView.extend({
  position: 'top-scroll-region'
});

PegasusTemplate.ScrollRegionBottomView = PegasusTemplate.ScrollRegionView.extend({
  position: 'bottom-scroll-region'
});
